/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState } from 'react';
import { Button, Checkbox, Heading, Spacer } from 'school-space-client/components';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center'
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative'
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700]
        }
    },
    fabProgress: {
        color: green[500],
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }
}));

const css = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
    },
    contentWrapper: {
        flexGrow: '1'
    },
    button: theme => ({
        maxWidth: theme.layout.baseline * 16
    })
};

const WelcomeTermsConditions = ({
    onChangeStep,
    customer,
    setCustomer,
    verificationsSteps,
    loading
}) => {
    const classes = useStyles();
    const [agree, setagree] = useState({
        termsConditionsAgreed: false,
        chargesDepositAgreed: false,
        cancellationPolicy: false,
        safeguardingDeclaration: false
    });
    const clickAction = async () => {
        if (!loading) {
            setCustomer({
                termsAgreed: true,
                ...customer
            });
            onChangeStep(verificationsSteps[3]);
        }
    };

    const shallCreateAccount = () => {
        if (
            agree.termsConditionsAgreed === false ||
            agree.chargesDepositAgreed === false ||
            agree.cancellationPolicy === false ||
            agree.safeguardingDeclaration === false
        ) {
            return true;
        }
        return false;
    };

    return (
        <div className={classes.root}>
            <form>
                <Heading level="3" size="x-large" styles={css.header}>
                    Welcome to School Space!{' '}
                </Heading>
                <Spacer height={1} />
                <p>
                    Thank you so much for choosing to book with School Space, we’re delighted to
                    have you join us. Before you get started we just need to confirm a few things.
                </p>
                <p>
                    Below you will find our Terms and Conditions as well as other important
                    documents that you need to read and confirm that you agree with. They will
                    explain how we run things around here, as well as including important
                    information on how we’re making sure to keep you, and our partner schools, safe.{' '}
                </p>
                <p>
                    These are legally binding documents that form your contract with us, so make
                    sure to read them carefully. Once you’ve completed this you will be taken to
                    your account dashboard. See you there!
                </p>
                <Spacer height={0.5} />
                <Checkbox
                    name="agree"
                    label="I agree to "
                    labelStyles={{ marginRight: 2 }}
                    linkLabel=" Terms & Conditions"
                    link="https://school-space.org/terms-conditions"
                    checked={agree.termsConditionsAgreed}
                    onChange={checked => {
                        setagree({
                            ...agree,
                            termsConditionsAgreed: checked
                        });
                    }}
                />

                <Spacer height={0.5} />
                <Checkbox
                    name="chargesDepositAgreed"
                    label="I agree to "
                    labelStyles={{ marginRight: 2 }}
                    link="https://school-space.org/terms-conditions/hire-charges-deposit-terms/"
                    linkLabel=" Hire Charges & Deposit Terms"
                    checked={agree.chargesDepositAgreed}
                    onChange={checked => {
                        setagree({
                            ...agree,
                            chargesDepositAgreed: checked
                        });
                    }}
                />
                <Spacer height={0.5} />
                <Checkbox
                    name="cancellationPolicy"
                    label="I agree to "
                    linkLabel=" Cancellation policy"
                    labelStyles={{ marginRight: 2 }}
                    link="https://school-space.org/terms-conditions/school-space-cancellation-policy/"
                    checked={agree.cancellationPolicy}
                    onChange={checked => {
                        setagree({
                            ...agree,
                            cancellationPolicy: checked
                        });
                    }}
                />
                <Spacer height={0.5} />
                <Checkbox
                    name="safeguardingDeclaration"
                    label="I agree to "
                    labelStyles={{ marginRight: 2 }}
                    linkLabel=" Safeguarding declaration"
                    link="https://school-spacehelp.zendesk.com/hc/en-gb/articles/5148728874525-Safeguarding-Policy"
                    checked={agree.safeguardingDeclaration}
                    onChange={checked => {
                        setagree({
                            ...agree,
                            safeguardingDeclaration: checked
                        });
                    }}
                />
                <Spacer />
                <div className={classes.wrapper}>
                    <Button
                        styles={css.button}
                        state="primary"
                        onClick={() => shallCreateAccount && clickAction()}
                        disabled={shallCreateAccount()}
                    >
                        Create Account
                    </Button>
                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>
            </form>
        </div>
    );
};

WelcomeTermsConditions.propTypes = {
    onChangeStep: PropTypes.func.isRequired,
    customer: PropTypes.shape({
        onBoarding: PropTypes.bool,
        customerType: PropTypes.string,
        created_at: PropTypes.string,
        discount: PropTypes.number,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        organisation: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string,
        termsAgreed: PropTypes.bool,
        address: PropTypes.shape({
            addressLine1: PropTypes.string,
            addressLine2: PropTypes.string,
            townCity: PropTypes.string,
            postCode: PropTypes.string,
            country: PropTypes.string
        }),
        setCustomer: PropTypes.func
    }).isRequired,
    setCustomer: PropTypes.func.isRequired,
    verificationsSteps: PropTypes.arrayOf(PropTypes.string).isRequired,
    loading: PropTypes.bool.isRequired
};
export default WelcomeTermsConditions;
